const layers: symbol[] = [];

export const useModalLayer = () => {
    const layer = Symbol('modalLayer');

    const enterLayer = (): void => {
        if (layers.includes(layer)) {
            return;
        }

        layers.push(layer);
    };

    const leaveLayer = (): void => {
        const index = layers.indexOf(layer);

        if (index === -1) {
            return;
        }

        layers.splice(index, 1);
    };

    const isTopLayer = (): boolean => layers[layers.length - 1] === layer;

    return { enterLayer, leaveLayer, isTopLayer };
};
